var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.referals,"items-per-page":15},scopedSlots:_vm._u([{key:"item.loginDateCreated",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(new Date(item.loginDateCreated).toLocaleDateString())+" ")]}},{key:"item.paymentSum",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.paymentSum != null ? _vm.$options.filters.toCurrency(item.paymentSum) : "—")+" ")]}},{key:"item.accruedTotal",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("toCurrency")(item.accruedTotal)))]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }